__webpack_require__.p = "https://footer.tbconline.app/static/";